// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
import 'fetch-ie8'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import layer from 'vue-layer-mobile'
import 'vue-layer-mobile/need/layer.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css'
import './assets/iconfont/iconfont.css'
import './router/di-ding-routers'
import './components/common/styles/common.css'
import routerHelper from './mixins/mixin'
import VueRouter from 'vue-router'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueAliplayerV2 from 'vue-aliplayer-v2'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'videojs-flash'
import 'vue-video-player/src/custom-theme.css'
import echarts from 'echarts'
import 'echarts-liquidfill'
// import * as echarts from 'echarts'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import dataV from '@jiaminghi/data-view'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import animated from 'animate.css'
import 'vue-fabric/dist/vue-fabric.min.css'
import { Fabric } from 'vue-fabric'
// import Print from 'vue-print-nb'
// import '@supermap/vue-iclient3d-webgl/dist/styles/vue-iclient3d-webgl.min.css'
// import VueiClient from '@supermap/vue-iclient3d-webgl'
import htmlToPdf from './utils/htmlToPdf'
import { bus } from './utils/bus'
import './assets/font/fontFamily.less'
// import Print from './utils/print'
import 'lib-flexible'
import JsonExcel from 'vue-json-excel'

promise.polyfill()

axios.defaults.withCredentials = true

let loadinginstace

axios.interceptors.request.use(
  config => {
    loadinginstace = window.$$vm.$loading({
      lock: true,
      text: '请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    config.headers['kj-type'] = 'gy'
    if (bus.global.yqCode) {
      config.headers['yq-app-code'] = bus.global.yqCode
    }
    if (bus.global.token) {
      config.headers['token'] = bus.global.token
    }
    if (config.url.indexOf('yq-upper') !== -1) {
      if (bus.global.upperData.groupAppCode) {
        config.headers['group-app-code'] = bus.global.upperData.groupAppCode
      }
      if (bus.global.upperData.token) {
        config.headers['token'] = bus.global.upperData.token
      }
    }
    return config
  },
  err => {
    loadinginstace.close()
    return Promise.reject(err)
  })

axios.interceptors.response.use(
  res => {
    if (res.data.data === '91007') {
      bus.global.token = ''
      bus.global.upperData.token = ''
    }
    loadinginstace.close()
    return res
  },
  err => {
    loadinginstace.close()
    if (err.response.data.data) {
      if (err.response.data.data === '91007' || err.response.data.data === 91007) {
        bus.global.token = ''
        bus.global.upperData.token = ''
      }
    }
    return Promise.reject(err)
  })

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.use(layer)
Vue.use(VueRouter)
Vue.use(VueAliplayerV2)
Vue.use(VideoPlayer)
Vue.use(dataV)
Vue.use(VueAwesomeSwiper)
Vue.use(htmlToPdf)
Vue.use(animated)
Vue.use(Fabric)
// Vue.use(Print)
// Vue.use(VueiClient)
Vue.component('downloadExcel', JsonExcel)
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.mixin(routerHelper)

Vue.config.productionTip = false

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.$$vm = vue

export {
  router
}



// WEBPACK FOOTER //
// ./src/main.js